/* TODO PB
 * 1. Implement normlizr
 * 2. Implement data validation at runtime
 */
import {
    RequesterTransformers,
    RequesterOptions,
} from './types';

abstract class BaseRequester<T> {
    protected requester: T;
    protected apiVersion: string;
    protected transformers: RequesterTransformers;

    constructor({
        requester,
        transformers = {
            request: [],
            response: []
        },
        apiVersion = 'v1',
    }: RequesterOptions = {}) {
        this.requester = requester;
        this.transformers = transformers;
        this.apiVersion = apiVersion;
    }

    setVersion(version: 'v1') {
        this.apiVersion = version;

        return this;
    }

    setTransformers(transformers: RequesterTransformers) {
        this.transformers = {
            ...this.transformers,
            ...transformers
        };

        return this;
    }

    protected prepareUrlWithVersion(param: string | { url: string, }): string {
        if (typeof param === 'object') {
            return `${this.apiVersion}/${param.url}`;
        }

        return `${this.apiVersion}/${param}`;
    }

    protected getTransformers(
        originalTransformers: { transformResponse?: any, transformRequest?: any } | undefined,
        { merge = true } = {}
    ) {
        const { request = [], response = [], } = this.transformers;

        if (!request.length && !response.length) {
            return {};
        }

        if (!merge) {
            return {
                transformRequest: [
                    ...request,
                ],

                transformResponse: [
                    ...response,
                ],
            };
        }

        return {
            transformRequest: [
                ...originalTransformers?.transformRequest ?? [],
                ...request,
            ],

            transformResponse: [
                ...originalTransformers?.transformResponse ?? [],
                ...response,
            ],
        };
    }
}

export default BaseRequester;
